export enum EntityApiEnum {
    USER        = '/user',

    CLIENT      = '/organization/client',
    EMPLOYEE    = '/organization/employee',
    VEHICLE     = '/organization/vehicle',
    MACHINE     = '/organization/machine',
    SUPPLIER    = '/organization/supplier',
    EQUIPMENT   = '/organization/equipment',
    OPERATION   = '/organization/operation',
    ORDER       = '/order',
    POSITION       = '/position',
    WORKPHASE       = '/workphase',
    SHIPPING       = '/shipping',
    WORKFLOW       = '/workflow',
    EQUIPMENT_REQUEST       = '/equipment-request',
   

    ENTITY_TYPE   = '/shared/lookup/entity-type',
  
}

export enum EtiquetteApiEnum {
    CLIENT      = EntityApiEnum.CLIENT + "/etiquette",
    EMPLOYEE    = EntityApiEnum.EMPLOYEE + "/etiquette",
    VEHICLE     = EntityApiEnum.VEHICLE + "/etiquette",
    MACHINE     = EntityApiEnum.MACHINE + "/etiquette",
    SUPPLIER    = EntityApiEnum.SUPPLIER + "/etiquette",
    EQUIPMENT   = EntityApiEnum.EQUIPMENT + "/etiquette",
    OPERATION   = EntityApiEnum.OPERATION + "/etiquette",

}

export enum ModelApiEnum {
    CLIENT      = EntityApiEnum.CLIENT + "/model",
    EMPLOYEE    = EntityApiEnum.EMPLOYEE + "/model",
    VEHICLE     = EntityApiEnum.VEHICLE + "/model",
    MACHINE     = EntityApiEnum.MACHINE + "/model",
    SUPPLIER    = EntityApiEnum.SUPPLIER + "/model",
    EQUIPMENT   = EntityApiEnum.EQUIPMENT + "/model",
    ORDER       = EntityApiEnum.ORDER + "/model",
    OPERATION   = EntityApiEnum.OPERATION + "/model",

}


export enum CommentApiEnum {

    ORDER    = EntityApiEnum.ORDER + "/comment",

}

export enum AppointmentApiEnum {

    ORDER       = EntityApiEnum.ORDER + "/appointment",

  
    USER   = EntityApiEnum.USER + "/appointment",
}

export enum LookupApiEnum {
    USER      		=   'USER',
    CLIENT     		=	'CLIENT'     	,
    EMPLOYEE   		=	'EMPLOYEE'   	,
    VEHICLE    		=	'VEHICLE'    	,
    MACHINE    		=	'MACHINE'    	,
    SUPPLIER   		=	'SUPPLIER'   	,
                        
    APPOINTMENT     =   'APPOINTMENT'   ,
    ORDER       	=	'ORDER'   ,
}

